import { FormikHelpers, useFormik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { authApi } from "@api";
import { ComponentSignUpTel } from "@components";
import {
    PATH_HOME,
    PATH_LINE_TELE_OTP,
    PATH_SIGN_IN,
    PATH_WELCOME,
    enumExternalMethod,
} from "@configs";
import { IAuth, IAuthConfig, IPhone } from "@interfaces";
import liff from "@line/liff";
import {
    addConfigClient,
    resetAuth,
    selectAuth,
    selectConfigClient,
    selectMerchant,
    setAuth,
    setConfigClient,
    setExternalLogin,
    setFromLogin,
    setLoading,
} from "@redux";
import { formatMessage, useNotify } from "@utils";

export const ModuleLineTelSignUp = () => {
    //page hooks
    const dispatch = useDispatch();
    const { error, success } = useNotify();
    const { t } = useTranslation();
    const history = useHistory();
    //page state
    const [errorPhone, setError] = useState<string>();
    const { lineToken } = useSelector(selectAuth);
    const { _id } = useSelector(selectMerchant);
    const configClient = useSelector(selectConfigClient);
    const merchant = useSelector(selectMerchant);
    //page variable
    const initialValues: IPhone = {
        phoneNumber: "",
    };

    const handleLogin = async (values: IPhone, { setSubmitting }: FormikHelpers<IPhone>) => {
        console.log("handle login line start ********************");
        console.log("phoneNum", values.phoneNumber);
        console.log("errorPhone", errorPhone);
        if (errorPhone) return;

        if (!values.phoneNumber) {
            setError(t("validation.isNumber"));
            return;
        }

        try {
            setSubmitting(true);
            dispatch(setLoading(true));
            let payload = {
                phoneNumber: values.phone || "",
                ...lineToken,
            };
            console.log(
                "linephonelogin payload : ",
                Object.keys(payload),
                Object.keys(payload).length <= 1
            );
            console.log(
                "check condition",
                lineToken === null,
                lineToken === undefined,
                Object.keys(payload).length <= 1
            );
            if (lineToken === null || lineToken === undefined || Object.keys(payload).length <= 1) {
                error("Line Token is Undefined. Please Login with Line again.");
                setSubmitting(false);
                localStorage.clear();
                dispatch(resetAuth());
                history.push(PATH_SIGN_IN);
            }
            const res = await authApi.clientLinePhoneLogin(payload);
            const data = res.data as IAuth;
            if (data) {
                dispatch(setExternalLogin({ type: enumExternalMethod.TEL, isSignUp: false }));
                window.sessionStorage.setItem("phoneNumber", values?.phone || "");
                window.sessionStorage.setItem("remember", (true || "").toString());
                if (res.data.isOtp) {
                    history.push(PATH_LINE_TELE_OTP);
                } else {
                    const data = res.data.token as IAuthConfig;
                    const message =
                        window.localStorage.i18nextLng === "th"
                            ? "ยืนยันหมายเลขโทรศัพท์สำเร็จ! "
                            : " Verify phone number successfully!";
                    const remember = window.sessionStorage.getItem("remember");
                    const authData = remember
                        ? { ...data, merchantId: _id || "" }
                        : { ...data, refreshToken: null, merchantId: _id || "" };
                    dispatch(setAuth(authData));
                    if (_id) {
                        const index = configClient.findIndex((item) => item.merchantId === _id);
                        if (index >= 1) {
                            dispatch(
                                setConfigClient({
                                    index,
                                    configClient: {
                                        merchantId: _id || "",
                                        token: authData,
                                    },
                                })
                            );
                        } else {
                            dispatch(
                                addConfigClient({
                                    merchantId: _id || "",
                                    token: authData,
                                })
                            );
                        }
                        // setCheckSuccess(true);
                        success(message);

                        if (
                            (merchant?.signUpSettings?.signUpMethod ===
                                enumExternalMethod.LINEOA_TEL ||
                                merchant?.signUpSettings?.signUpMethod ===
                                    enumExternalMethod.LINE) &&
                            liff.isInClient() &&
                            message
                        ) {
                            sessionStorage.setItem("SING_UP", "true");
                            history.push(PATH_HOME);
                        } else {
                            history.push(PATH_HOME);
                        }
                        dispatch(setFromLogin(true));
                    }
                }
                // history.push(PATH_LINE_TELE_OTP);
            }
        } catch (errors: any) {
            console.error(errors);
            // const { message } = errors.response.data;
            localStorage.clear();
            if (errors.response) {
                if (formatMessage(errors.response) === "Token should not be null or undefined") {
                    //
                }
                setSubmitting(false);
                localStorage.clear();
                dispatch(resetAuth());
                console.log("LineTel 1");
                history.push(PATH_WELCOME);
                error(formatMessage(errors.response));
            } else {
                setSubmitting(false);
                localStorage.clear();
                dispatch(resetAuth());
                console.log("LineTel 2");
                // history.push(PATH_WELCOME);
            }
        } finally {
            setSubmitting(false);
            dispatch(setLoading(false));
        }

        console.log("handle login line end ********************");
    };
    const { values, handleSubmit, isSubmitting, setFieldTouched, setFieldValue } = useFormik({
        initialValues: initialValues,
        onSubmit: handleLogin,
    });

    return (
        <ComponentSignUpTel
            values={values}
            handleSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            setFieldTouched={setFieldTouched}
            setFieldValue={setFieldValue}
            errorPhone={errorPhone || ""}
            setError={setError}
        />
    );
};
function setCheckSuccess(arg0: boolean) {
    throw new Error("Function not implemented.");
}
